module.exports = __webpack_public_path__ + "img/线条2.5f68c686.png";